import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'home',
	// component: HomeView,
	redirect: '/login',
},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/LoginView.vue')
	},
	{
		path: '/first',
		component: () => import('../views/FirstView.vue'),
		meta: { requiresAuth: true }, // 需要登录才能访问
		children: [{
			path: 'search',
			name: 'search',
			component: () => import('../views/lookUP/SearchView.vue')
		},
			{
				path: 'rank',
				name: 'rank',
				component: () => import('../views/lookUP/RankView.vue')
			},
			{
				path: 'faDev',
				name: 'faDev',
				component: () => import('../views/fadev/fadevView.vue')
			},
			{
				path: 'comparison',
				name: 'comparison',
				component: () => import('../views/lookUP/ComparisonView.vue')
			},
			{
				path: 'retrieval',
				name: 'retrieval',
				component: () => import('../views/Creative/RetrievalView.vue')
			},
			{
				path: 'simple',
				name: 'simple',
				component: () => import('../views/Creative/SimpleView.vue')
			},
			{
				path: 'antistop',
				name: 'antistop',
				component: () => import('../views/Creative/AntistopView.vue')
			},
			{
				path: 'intelbras',
				name: 'intelbras',
				component: () => import('../views/Creative/IntelbrasView.vue')
			},
			{
				path: 'topic',
				name: 'topic',
				component: () => import('../views/Creative/TopicView.vue')
			},
			{
				path: '/Topicdetail/:id',
				name: 'detail',
				component: () => import('../views/Creative/TopicDetail.vue'),
			},
			{
				path: 'retrieve',
				name: 'retrieve',
				component: () => import('../views/Analysis/RetrieveView.vue')
			},
			{
				path: 'ranks',
				name: 'ranks',
				component: () => import('../views/Analysis/RankingView.vue')
			},
			{
				path: 'admin',
				name: 'admin',
				component: () => import('../views/Analysis/AdminView.vue')
			},
			{
				path: 'favorite',
				name: 'favorite',
				component: () => import('../views/FavoriteView.vue')
			},
			{
				path: 'renewal',
				name: 'renewal',
				component: () => import('../views/RenewalView.vue')
			},
			{
				path: '/archel/:id',
				name: 'searchel',
				component: () => import('../views/Analysis/SearchsView.vue')
			},
			{
				path: '',
				name: "",
				redirect: '/first/faDev'
			},
		]
	},
	{
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/AboutView.vue')
	}
]

const router = new VueRouter({
	routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
	// 检查路由是否需要登录权限
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// 检查是否已登录
		const token = localStorage.getItem('token')
		const user = localStorage.getItem('user')

		if (!token || !user) {
			// 未登录则跳转到登录页
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
			return
		}

		// 检查登录是否超时
		const lastActiveTime = localStorage.getItem('lastActiveTime')
		const now = new Date().getTime()

		if (lastActiveTime && (now - parseInt(lastActiveTime)) > 30 * 60 * 1000) { // 30分钟超时
			// 清除登录信息
			localStorage.removeItem('token')
			localStorage.removeItem('user')
			localStorage.removeItem('lastActiveTime')

			// 提示用户
			Vue.prototype.$message.warning('登录已过期，请重新登录')

			// 跳转登录页
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
			return
		}

		// 更新最后活动时间
		localStorage.setItem('lastActiveTime', now.toString())
		next()
	} else if (to.path === '/login' && localStorage.getItem('token')) {
		// 如果已登录且要跳转登录页，则重定向到首页
		next({ path: '/first' })
	} else {
		next()
	}
})

export default router
